<app-home *ngIf="page=='home'"></app-home>
<app-signpost *ngIf="page=='signpost'"></app-signpost>